import React, { useState } from "react";
import { SFIcons, SFIconButton, SFDropdown, SFUseStyled } from "@sf-core";

const { styled } = SFUseStyled();

const StyledIconButton = styled(SFIconButton)(({ theme }) => ({
  color: theme.palette.grey300.main,
}));

const SFMoreMenu = ({ items, className = "more-button" }) => {
  const [dropDownMenu, setDropDownMenu] = useState({
    open: false,
    target: null,
  });

  const handleOpendropDownMenu = (e) => {
    setDropDownMenu({ open: true, target: e.target });
  };

  return (
    <>
      {items?.length > 0 && (
        <>
          <StyledIconButton
            onClick={(e) => handleOpendropDownMenu(e)}
            variant="transparent"
            className={className}
          >
            <SFIcons.SFMoreVertIcon />
          </StyledIconButton>
          <SFDropdown
            open={dropDownMenu.open}
            anchorEl={dropDownMenu.target}
            onClose={() => setDropDownMenu({ open: false })}
            items={items}
            position={85}
            placement={"bottom"}
          />
        </>
      )}
    </>
  );
};

export default SFMoreMenu;
